import { useNavigate } from 'react-router-dom';

/* Context */
import { useAuthContext } from '../../context/AuthContext';

/* CSS */
import styles from "./AuthHeader.module.css";

/* Icons */
import travelbuddy_logo from '../../assets/icons/travelbuddy_logo.svg';
import x from '../../assets/icons/x.svg';

const AuthHeader = ({ showCancel = true, currentStep }) => {

    const navigate = useNavigate();
    const { currentUser } = useAuthContext();

    // Logged-in users go to the app home; logged-out users to login ('/' would just bounce there anyway).
    const goHome = () => navigate(currentUser ? '/' : '/login');

    return (
        <div className={styles.header}>
            <div className={styles.headerWrapper}>
                <div className={styles.travelBuddy} onClick={goHome}>
                    <img
                        src={travelbuddy_logo}
                        alt="TravelBuddy logo"
                        className={styles.travelBuddyLogo}
                    />
                    <div className={styles.travelBuddyText}>TravelBuddy</div>
                </div>

                {/* Progress bar */}
                {currentStep && (
                    <div className={styles.progressBarContainer}>
                        {/* Inline styles to dynamically change the width based on the step */}
                        <div className={styles.progressTrack}>
                            <div
                                className={styles.progressFill}
                                style={{ width: currentStep === 'password' ? '50%' : '100%' }}
                            />
                        </div>
                        <div className={styles.progressLabels}>
                            <span style={{ fontWeight: currentStep === 'password' ? '600' : '400' }}>Password</span>
                            <span style={{ fontWeight: currentStep === 'profile' ? '600' : '400' }}>Profile</span>
                        </div>
                    </div>
                )}

                {/* Cancel button */}
                {showCancel && (
                    <button
                        type="button"
                        className={styles.cancelButton}
                        onClick={goHome}
                        title="Cancel"
                    >
                        <img src={x} alt="Cancel" className={styles.x} />
                    </button>
                )}

            </div>
        </div>
    );
};

export default AuthHeader;
